export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-cream/80 py-20 px-6 text-center">
    <p className="font-script text-5xl text-peach">Emma & Jhonny</p>
    <p className="mt-6 font-serif tracking-[0.35em] uppercase text-xs text-cream/60">
      10 · Octubre · 2026 — Indianapolis, Indiana
    </p>
    <div className="mt-8 flex justify-center gap-8 text-[11px] uppercase tracking-[0.25em] text-cream/50">
      <a data-testid="footer-link-historia" href="#historia" className="hover:text-peach transition-colors">Historia</a>
      <a data-testid="footer-link-detalles" href="#detalles" className="hover:text-peach transition-colors">Detalles</a>
      <a data-testid="footer-link-rsvp" href="#rsvp" className="hover:text-peach transition-colors">RSVP</a>
      <a data-testid="footer-link-admin" href="/admin" className="hover:text-peach transition-colors">Admin</a>
    </div>
    <p className="mt-12 text-xs text-cream/40">Hecho con amor</p>
  </footer>
);
